import { IEnvironment } from '../models';
import { environment } from './environment';

export const environmentHtf: IEnvironment = {
  ...environment,
  envName: 'hotfix',
  chatbotApiUrl: 'https://immomio-ida.meho.ai',
  production: true,
};
